import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import MoneyAmount from '@common/components/moneyAmount';
import Config from '@skin_config';
import { getAuthData } from '@common/helpers/auth';
import { GetCurrencyConfig } from '@common/helpers/selectors';

const Money = ({ amount }) => {
  const authData = getAuthData();
  const currencyConfig = useSelector((state) => (
    GetCurrencyConfig(state, Config.currencySymbolRounding)
  ));

  return (
    <MoneyAmount
      config={Config}
      currencyConfig={{ name: authData.currency, ...currencyConfig }}
      amount={amount}
    />
  );
};

Money.propTypes = {
  amount: PropTypes.number,
};

export default Money;
